import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';

@Component({
  selector: 'bd-logo',
  imports: [RouterModule, SharedI18nModule],
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  readonly routerLink = input('/');
  readonly isLastToolbarItem = input(false);
  readonly logoClicked = output<void>();
}
